function splitGraphemes(str: string): string[] {
  if (typeof Intl !== 'undefined' && 'Segmenter' in Intl) {
    const segmenter = new Intl.Segmenter(undefined, {granularity: 'grapheme'});
    return [...segmenter.segment(str)].map(s => s.segment);
  }
  // Fallback for environments without Intl.Segmenter
  return Array.from(str);
}

export function sanitizeDownloadFilename(value: string, maxLength: number = 240): string {
  let sanitized = value
    .replaceAll(/[\\/:*?"<>|\u0000-\u001F]/g, '_')
    .replaceAll(/\s+/g, ' ')
    .replaceAll(/_+/g, '_')
    .trim();
  sanitized = sanitized.replaceAll(/^\.+/g, '');
  sanitized = sanitized.replaceAll(/\.\.+/g, '.');
  sanitized = sanitized.replaceAll(/[. ]+$/g, '');
  const graphemes = splitGraphemes(sanitized);
  if (graphemes.length > maxLength) {
    return graphemes.slice(0, maxLength).join('').replaceAll(/[. ]+$/g, '');
  }
  return sanitized;
}
